import { clone } from 'lodash'
import axiosClient from './axiosClient'

const registrationApi = {
  getRegistrations: (params, signal) => {
    const clonedParams = clone(params)
    clonedParams.page =
      clonedParams.page === 0 ? clonedParams.page : clonedParams.page - 1
    const url = '/registration'

    return axiosClient.get(url, { params: clonedParams, signal })
  },

  getDetail: (registrationId) => {
    const url = `/registration/${registrationId}`

    return axiosClient.get(url)
  },

  getPrototype: (params) => {
    const url = '/registration/prototype'

    return axiosClient.get(url, params)
  },

  createRegistration: (params) => {
    const url = '/registration'

    return axiosClient.post(url, params)
  },

  updateRegistration: (registrationId, params) => {
    const url = `/registration/${registrationId}`

    return axiosClient.put(url, params)
  },

  exportRegistration: (params) => {
    const url = '/registration/export'

    return axiosClient.post(url, params, { responseType: 'blob' })
  },

  exportRegistrationById: (registrationId) => {
    const url = `/registration/export/${registrationId}`

    return axiosClient.get(url, { responseType: 'blob' })
  },

  deleteRegistration: (registrationId) => {
    const url = `/registration/${registrationId}`

    return axiosClient.delete(url)
  },

  syncRegistration: (messageId) => {
    const url = `/invoice/check-message`

    return axiosClient.get(url, { params: { messageId } })
  },

  hsmSignRegistration: (params) => {
    const url = '/registration/hsm-sign-registration'

    return axiosClient.post(url, params)
  },

  getCertificateDetailHSM: (params) => {
    const url = '/registration/get-certificate-detail-hsm'

    return axiosClient.post(url, params)
  },

  createRegistrationAccountingDocuments: (params) => {
    const url = '/registration/accountingDocuments'

    return axiosClient.post(url, params)
  },

  updateRegistrationAccountingDocuments: (registrationId, params) => {
    const url = `/registration/accountingDocuments/${registrationId}`

    return axiosClient.put(url, params)
  },

  exportRegistrationAccountingDocuments: (params) => {
    const url = '/registration/accountingDocuments/export'

    return axiosClient.post(url, params, { responseType: 'blob' })
  },
}

export default registrationApi
